module.exports = __webpack_public_path__ + "img/sns_twitter.b90bf77.svg";